module.exports = __webpack_public_path__ + "img/sec4_img3.5c254c01.jpg";